import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds, MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";

const TITLE = "حساب الفرق بين تاريخين أو عمرين";
const DESCRIPTION =
  "تقوم هذه الحاسبة بحساب المدة بين تاريخين بالميلادي بالإضافة إلى حساب الأيام بين تاريخين وتحديد الوقت المنقضي والمتبقي بدقة بالسنوات والشهور والأيام.";
const KEYWORDS =
  "حساب الفرق بين الأعمار, حساب فرق العمر بين شخصين, حاسبة الفارق العمري, حساب الفارق الزمني بدقة, الفرق بين تاريخين ميلادي";
const OG_URL = "https://do-calculate.com/calculator/ar/gregoriandifferences/";

const GREGORIAN_MONTHS = [
  "كانون الثاني", "شباط", "آذار", "نيسان", "أيار", "حزيران",
  "تموز", "آب", "أيلول", "تشرين الأول", "تشرين الثاني", "كانون الأول"
];

function AgeCalculatorGregorian() {
  const [d1, setD1] = useState({ day: "1", month: "1", year: "1990" });
  const [d2, setD2] = useState({ day: new Date().getDate().toString(), month: (new Date().getMonth() + 1).toString(), year: new Date().getFullYear().toString() });
  const [differences, setDifferences] = useState(null);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const calculateDifferences = () => {
    setIsLoading(true);
    const date1 = new Date(parseInt(d1.year), parseInt(d1.month) - 1, parseInt(d1.day));
    const date2 = new Date(parseInt(d2.year), parseInt(d2.month) - 1, parseInt(d2.day));

    if (isNaN(date1.getTime()) || isNaN(date2.getTime())) {
      setError("يُرجى إدخال تواريخ صحيحة");
      setDifferences(null);
      setIsLoading(false);
      return;
    }

    let startDate = date1 < date2 ? date1 : date2;
    let endDate = date1 < date2 ? date2 : date1;

    let years = endDate.getFullYear() - startDate.getFullYear();
    let months = endDate.getMonth() - startDate.getMonth();
    let days = endDate.getDate() - startDate.getDate();

    if (days < 0) {
      months--;
      const lastMonth = new Date(endDate.getFullYear(), endDate.getMonth(), 0);
      days += lastMonth.getDate();
    }
    if (months < 0) {
      years--;
      months += 12;
    }

    const totalMilliseconds = endDate - startDate;
    const totalSeconds = Math.floor(totalMilliseconds / 1000);
    const totalMinutes = Math.floor(totalSeconds / 60);
    const totalHours = Math.floor(totalMinutes / 60);
    const totalDays = Math.floor(totalHours / 24);

    setDifferences({
      years, months, days,
      totalDays,
      totalWeeks: Math.floor(totalDays / 7),
      totalMonths: years * 12 + months,
      totalHours,
      totalMinutes,
      totalSeconds,
      startDateStr: startDate.toLocaleDateString("ar-EG", { weekday: "long", year: "numeric", month: "long", day: "numeric" }),
      endDateStr: endDate.toLocaleDateString("ar-EG", { weekday: "long", year: "numeric", month: "long", day: "numeric" }),
      centuryPercentage: ((totalDays / (100 * 365.25)) * 100).toFixed(2),
      solarYears: (totalDays / 365.25).toFixed(2),
      workDays: Math.floor((totalDays / 7) * 5),
    });
    setError(null);
    setIsLoading(false);
  };

  const renderSelectDate = (data, setData, label) => (
    <div className="mb-4">
      <label ><strong>{label}:</strong></label>
      <div className="row">
        <div className="col-md-4">
          <select className="form-control" value={data.day} onChange={(e) => setData({ ...data, day: e.target.value })}>
            {Array.from({ length: 31 }, (_, i) => i + 1).map(d => <option key={d} value={d}>{d}</option>)}
          </select>
        </div>
        <div className="col-md-4">
          <select className="form-control" value={data.month} onChange={(e) => setData({ ...data, month: e.target.value })}>
            {GREGORIAN_MONTHS.map((m, i) => <option key={i + 1} value={i + 1}>{i + 1} - {m}</option>)}
          </select>
        </div>
        <div className="col-md-4">
          <select className="form-control" value={data.year} onChange={(e) => setData({ ...data, year: e.target.value })}>
            {Array.from({ length: 150 }, (_, i) => new Date().getFullYear() + 10 - i).map(y => <option key={y} value={y}>{y}</option>)}
          </select>
        </div>
      </div>
    </div>
  );

  return (
    <div className="rtl" style={{ direction: "rtl", textAlign: "right" }}>
      <SharedHelmet TITLE={TITLE} DESCRIPTION={DESCRIPTION} KEYWORDS={KEYWORDS} OG_URL={OG_URL} />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div className="bg-success text-white text-center p-3 rounded">
            <h1 style={{ fontSize: "20px", margin: 0 }}>{TITLE}</h1>
          </div>
          <div className="border border-light mt-3 p-3 bg-white shadow-sm">
            <div>
              <p>
                تقوم هذه الحاسبة بحساب المدة بين تاريخين سواء بالهجري أو
                بالميلادي بالإضافة إلى حساب الأيام بين تاريخين بواسطة حاسبة
                الأيام، وتحديد الوقت المنقضي والمتبقي بين أي تاريخين. تمكن
                "حاسبة الفرق بين عمرين" من حساب الفرق بين التاريخين المدخلين
                بالسنوات والشهور والأيام والساعات والدقائق والثواني. بالإضافة
                إلى ذلك، يشمل الحساب أيضًا حساب فرق العمر، الفرق بين تاريخين،
                حساب الفرق بين تاريخين، والفرق بين عمرين.
              </p>
              <p>
                استخدم هذه الحاسبة لتحقيق دقة عالية في حساب الفروق الزمنية،
                سواء كانت تلك الفروق تتعلق بالعمر بين شخصين أو بين تواريخ
                ميلاد محددة. ستحصل على نتائج دقيقة وشاملة تظهر الفارق بشكل
                تفصيلي، مما يتيح لك فهم أفضل للزمن والتوقيت بين الحوادث أو
                الأحداث.
              </p>
              <p>
                استمتع بتحديد الفارق العمري بدقة، واكتشاف الفروق الزمنية بين
                تواريخ معينة، واستخدام هذه المعلومات بشكل فعّال في مختلف
                السياقات الشخصية والمهنية. لا تتردد في استخدام هذه الأداة
                الفعالة للحصول على تحليل زمني شامل ودقيق.
              </p>
              <br />
            </div>

            <hr />
            <MobileUnderCalAds />
            <div className="calculatorStyle mb-4">
              <div className="p-3 mb-3 bg-success text-white text-center rounded">
                <h2 style={{ fontSize: "18px", margin: 0 }}>إدخال تواريخ الميلاد أو الأحداث</h2>
              </div>

              {renderSelectDate(d1, setD1, "التاريخ الأول")}
              {renderSelectDate(d2, setD2, "التاريخ الثاني")}

              <div className="text-center mt-4">
                <button className="btn btn-success btn-lg px-5" onClick={calculateDifferences} disabled={isLoading}>
                  {isLoading ? "جاري الحساب..." : "إحسب الفرق بين العمرين"}
                </button>
              </div>

              {error && <div className="alert alert-danger mt-3">{error}</div>}

              {differences && (
                <div className="mt-4 animate__animated animate__fadeIn">
                  <div className="alert alert-success" style={{ backgroundColor: "#d4edda", color: "#155724" }}>
                    <h3 style={{ fontSize: "19px" }}><strong>نتيجة حساب الفرق بين التاريخين:</strong></h3>
                    <div className="p-3 bg-white rounded border mt-2">
                      <strong>الفرق بين التاريخين هو:</strong>
                      <p style={{ fontSize: "22px", fontWeight: "bold", color: "#28a745", marginTop: "5px" }}>
                        {differences.years} سنة و {differences.months} شهر و {differences.days} يوم
                      </p>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <div className="card h-100 shadow-sm">
                        <div className="card-header bg-success text-white"><strong>الفرق بالتفصيل الدقيق</strong></div>
                        <div className="card-body">
                          <ul className="list-unstyled lh-lg">
                            <li>✓ السنوات: {differences.years}</li>
                            <li>✓ الأشهر: {differences.months}</li>
                            <li>✓ الأيام: {differences.days}</li>
                            <li>✓ الساعات: 0</li>
                            <li>✓ الدقائق: 0</li>
                            <li>✓ الثواني: 0</li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6 mb-3">
                      <div className="card h-100 shadow-sm">
                        <div className="card-header bg-success text-white"><strong>إحصائيات إجمالية</strong></div>
                        <div className="card-body">
                          <ul className="list-unstyled lh-lg">
                            <li>📅 إجمالي الأيام: {differences.totalDays.toLocaleString()} يوم</li>
                            <li>📅 إجمالي الأسابيع: {differences.totalWeeks.toLocaleString()} أسبوع</li>
                            <li>📅 إجمالي الأشهر: {differences.totalMonths.toLocaleString()} شهر</li>
                            <li>⏰ إجمالي الساعات: {differences.totalHours.toLocaleString()} ساعة</li>
                            <li>⏰ إجمالي الدقائق: {differences.totalMinutes.toLocaleString()} دقيقة</li>
                            <li>⏰ إجمالي الثواني: {differences.totalSeconds.toLocaleString()} ثانية</li>
                            <li>💼 أيام العمل التقريبية: {differences.workDays.toLocaleString()} يوم</li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="card shadow-sm border-0 bg-light">
                    <div className="card-body">
                      <h4 style={{ fontSize: "17px" }}><strong>معلومات تفصيلية عن التاريخين</strong></h4>
                      <p className="mb-1"><strong>التاريخ الأول:</strong> {differences.startDateStr}</p>
                      <p><strong>التاريخ الثاني:</strong> {differences.endDateStr}</p>
                      <hr />
                      <strong>هذه الفترة تمثل:</strong>
                      <ul className="mt-2 lh-lg">
                        <li>{differences.centuryPercentage}% من قرن (100 سنة)</li>
                        <li>{differences.solarYears} سنة شمسية</li>
                        <li>{Math.floor(differences.totalDays / 30)} شهر تقريباً</li>
                      </ul>
                    </div>
                  </div>
                </div>
              )}
            </div>
            <RelatedLinks />
          </div>
        </div>
        <div className="col-md-4">
          <SecondAds />
          <MainCalculatorsList />
        </div>
      </div>
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">
                {" "}
                الفرق بين تاريخين في التقويم الميلادي: حساب الفارق العمري بين
                شخصين{" "}
              </div>
              <div className="info-section-body">
                <u>
                  <h2 style={{ fontSize: "16px" }}>
                    {" "}
                    الفرق بين تاريخين في التقويم الميلادي: حساب الفارق العمري
                    بين شخصين{" "}
                  </h2>{" "}
                </u>
                <p>
                  العمر هو جانب مهم في حياة الإنسان، وهو يعكس تجربته ونضوجه على
                  مر الزمن. يتطلب حساب الفرق بين تاريخين في التقويم الميلادي
                  معرفة دقيقة بالتواريخ والقدرة على تحويلها إلى فارق زمني بسيط.
                  في هذه المقالة، سنلقي نظرة على كيفية حساب الفرق العمري بين
                  شخصين أو بين تواريخ معينة في التقويم الميلادي.
                </p>
                <hr />
                <u>
                  <h2 style={{ fontSize: "16px" }}>
                    {" "}
                    المفهوم الأساسي لحساب الفرق العمري
                  </h2>{" "}
                </u>
                <p>
                  حساب الفرق بين الأعمار هو عملية تحديد عدد السنوات والأشهر
                  والأيام التي تفصل بين تاريخين معينين في التقويم الميلادي. يمكن
                  استخدام هذا الحساب في العديد من السياقات مثل حساب فرق العمر
                  بين شخصين، أو معرفة فرق السن بين تواريخ مهمة مثل التخرج، أو أي
                  مناسبة أخرى.
                </p>
                <hr />
                <u>
                  <h2 style={{ fontSize: "16px" }}>
                    {" "}
                    كيفية حساب الفرق العمري بين تواريخ ميلاد
                  </h2>{" "}
                </u>
                لحساب الفرق العمري بين تواريخ ميلاد معينة في التقويم الميلادي،
                يمكنك اتباع الخطوات التالية:
                <ul>
                  <li>
                    تحديد التواريخ: ابدأ بتحديد التواريخ التي تريد حساب الفرق
                    بينها.
                  </li>
                  <li>
                    تحويل التواريخ إلى أيام: قم بتحويل كل تاريخ إلى عدد من
                    الأيام ببساطة. على سبيل المثال، يمكنك تحويل كل تاريخ إلى عدد
                    من الأيام من بداية التقويم.
                  </li>
                  <li>
                    حساب الفارق: اطرح عدد الأيام الواحد من الآخر للحصول على
                    الفرق العمري بالأيام.
                  </li>
                  <li>
                    تحويل الفارق العمري: يمكن تحويل الفارق العمري بالأيام إلى
                    أشهر أو سنوات بالقسمة على عدد الأيام في الشهر أو السنة. على
                    سبيل المثال، هناك حوالي 30 يومًا في شهر.
                  </li>
                </ul>
                <hr />
                <u>
                  <h2 style={{ fontSize: "16px" }}>
                    {" "}
                    استخدام حاسبة الفرق بين عمرين او تاريخين{" "}
                  </h2>{" "}
                </u>
                <p>
                  لتسهيل عملية حساب الفرق العمري، يمكنك استخدام حاسبة الفرق
                  العمري عبر الإنترنت. هذه الأدوات تقدم حسابًا سريعًا ودقيقًا
                  للفرق بين التواريخ بالأيام والشهور والسنوات.
                </p>
                <hr />
                <u>
                  <h2 style={{ fontSize: "16px" }}>
                    {" "}
                    استخدامات حساب الفرق بين عمرين او تاريخين{" "}
                  </h2>{" "}
                </u>
                <p>
                  يمكن استخدام حساب الفرق العمري في العديد من السياقات مثل حساب
                  فرق العمر بين شخصين في علاقة، أو لتحديد فارق السن بين تواريخ
                  مهمة مثل تاريخ الزواج أو تاريخ الانتقال إلى منزل جديد. كما
                  يمكن استخدامه في الجوانب الإدارية والإحصائية.
                </p>
                <hr />
                <u>
                  <h2 style={{ fontSize: "16px" }}>
                    {" "}
                    كيف تعمل حاسبة الفرق بين عمرين{" "}
                  </h2>{" "}
                </u>
                هذه الحاسبة تقوم بحساب الفروقات في الأعمار بين تاريخين في
                التقويم الميلادي. فإذا قمت بتمرير تاريخين لتاريخي الميلاد، ستعيد
                الحاسبة فروقات الأعمار بينهما.
                <br />
                عند استخدام هذه الدالة، يجب تمرير التواريخ الميلادية في صيغة
                صحيحة مثل "YYYY-MM-DD". إذا تم تمرير تواريخ غير صحيحة، ستقوم
                الحاسبة بإلقاء خطأ وإرجاع رسالة تفيد بأنه يجب إدخال تواريخ
                صحيحة.
                <br />
                ستعود الحاسبة بنتيجة تحتوي على الفروقات بين التواريخ المدخلة في
                صيغة السنوات والشهور والأيام والساعات والدقائق والثواني. .
                <br />
              </div>
            </div>
          </div>
          <br />
          <u>
            {" "}
            <h2>اسئلة متكررة</h2>
          </u>
          <br />
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  ما هو حساب الفرق بين عمرين في التقويم الميلادي؟
                </h3>
              </div>
              <div className="info-section-body">
                حساب الفرق بين عمرين في التقويم الميلادي هو عملية تحديد الفارق
                الزمني بين تواريخ ميلادهما بالأعوام والأشهر والأيام. يتم ذلك
                عادة لمعرفة الفارق بين أعمار الأشخاص أو لأغراض أخرى.
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  كيف يمكن حساب الفرق بين عمرين في التقويم الميلادي؟
                </h3>
              </div>
              <div className="info-section-body">
                يمكنك حساب الفرق بين عمرين في التقويم الميلادي باتباع الخطوات
                التالية:
                <ol>
                  <li>تحديد تواريخ ميلاد الشخصين.</li>
                  <li>
                    تحويل تلك التواريخ إلى عدد من الأيام منذ تاريخ بداية التقويم
                    الميلادي.
                  </li>
                  <li>طرح الفارق بين الأيام للحصول على الفرق بالأيام.</li>
                  <li>تحويل الفارق بالأيام إلى أعوام وأشهر إذا كنت ترغب.</li>
                </ol>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  هل هناك حاسبة لحساب الفرق بين عمرين في التقويم الميلادي؟
                </h3>
              </div>
              <div className="info-section-body">
                نعم، يمكنك استخدام العديد من حاسبات الفرق العمري عبر الإنترنت
                لتسهيل هذه العملية. تقوم هذه الأدوات بحساب الفرق بدقة وبشكل
                سريع. ببساطة قم بإدخال تواريخ الميلاد وستحصل على الفرق بالأعوام
                والأشهر والأيام.
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  ما هي أهمية حساب الفرق بين عمرين في التقويم الميلادي؟
                </h3>
              </div>
              <div className="info-section-body">
                حساب الفرق بين عمرين في التقويم الميلادي يمكن أن يكون مهمًا
                للعديد من السياقات مثل معرفة الفرق بين أعمار الأشخاص في العلاقات
                الشخصية أو لأغراض تخطيط الأحداث والمناسبات الخاصة. كما يُستخدم
                في العديد من الجوانب الإدارية والإحصائية.
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  هل يمكن حساب الفرق بين عمرين يدويًا؟
                </h3>
              </div>
              <div className="info-section-body">
                نعم، يمكن حساب الفرق بين عمرين في التقويم الميلادي يدويًا بمعرفة
                تواريخ الميلاد وباستخدام القوانين الميلادية المعترف بها. الأمر
                يتطلب بعض الوقت والجهد، لكنه ممكن من الناحية الفنية.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default AgeCalculatorGregorian;
